import { render, staticRenderFns } from "./ApproverPhones.vue?vue&type=template&id=1376fb81&scoped=true&"
import script from "./ApproverPhones.vue?vue&type=script&lang=js&"
export * from "./ApproverPhones.vue?vue&type=script&lang=js&"
import style0 from "./ApproverPhones.vue?vue&type=style&index=0&id=1376fb81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1376fb81",
  null
  
)

export default component.exports